import { render, staticRenderFns } from "./bindingMobile.vue?vue&type=template&id=0b7d79f5&scoped=true&"
import script from "./bindingMobile.vue?vue&type=script&lang=js&"
export * from "./bindingMobile.vue?vue&type=script&lang=js&"
import style0 from "./bindingMobile.vue?vue&type=style&index=0&id=0b7d79f5&lang=less&scoped=true&"
import style1 from "./bindingMobile.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7d79f5",
  null
  
)

export default component.exports